import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === "en" ? "te" : "en";
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-2 rounded-lg transition-colors duration-200 font-medium"
            title={i18n.language === "en" ? "Switch to Telugu" : "Switch to English"}
        >
            <Languages className="h-4 w-4" />
            <span>{i18n.language === "en" ? "EN" : "TE"}</span>
        </button>
    );
};

export default LanguageSwitcher;
